"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const a=a=>a&&"string"!=typeof a?a+1:1;exports.calculateNextHighestZ=a
//# sourceMappingURL=styles.js.map
